(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["arctic-v2-accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    const timing = {
      duration: 440,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      fill: 'both',
    };

    const setDetailsState = (details, shouldOpen) => {
      const panel = details.querySelector('.arctic-v2-accordion__panel');
      if (!panel) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const currentAnimation = details.arcticAccordionAnimation;
      const startHeight = panel.getBoundingClientRect().height;

      if (currentAnimation) currentAnimation.cancel();

      if (shouldOpen) {
        details.open = true;
        details.classList.add('is-expanded');
      } else {
        details.classList.remove('is-expanded');
      }

      panel.style.height = `${startHeight}px`;
      const endHeight = shouldOpen ? panel.scrollHeight : 0;

      if (reducedMotion) {
        panel.style.height = shouldOpen ? 'auto' : '0px';
        details.open = shouldOpen;
        return;
      }

      const animation = panel.animate(
        [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
        timing
      );
      details.arcticAccordionAnimation = animation;

      animation.finished
        .then(() => {
          if (details.arcticAccordionAnimation !== animation) return;
          panel.style.height = shouldOpen ? 'auto' : '0px';
          details.open = shouldOpen;
          details.arcticAccordionAnimation = null;
          animation.cancel();
        })
        .catch(() => {});
    };

    const onSummaryClick = (event) => {
      const summary = event.currentTarget;
      const details = summary.closest('details');
      if (!details || !details.classList.contains('arctic-v2-accordion__details')) return;

      event.preventDefault();

      if (details.classList.contains('is-expanded')) {
        setDetailsState(details, false);
      } else {
        setDetailsState(details, true);
      }
    };

    const init = (root = document) => {
      root.querySelectorAll('.arctic-v2-accordion__details > summary').forEach((summary) => {
        if (summary.dataset.arcticAccordionBound === 'true') return;
        summary.dataset.arcticAccordionBound = 'true';
        const details = summary.closest('.arctic-v2-accordion__details');
        const accordion = summary.closest('.arctic-v2-accordion');
        const panel = details.querySelector('.arctic-v2-accordion__panel');
        accordion.dataset.accordionReady = 'true';
        details.classList.toggle('is-expanded', details.open);
        panel.style.height = details.open ? 'auto' : '0px';
        summary.addEventListener('click', onSummaryClick);
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["arctic-v2-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arctic-v2-delivery')) {
    customElements.define(
      'arctic-v2-delivery',
      class extends HTMLElement {
        connectedCallback() {
          const minDays = Number(this.dataset.minDays) || 3;
          const maxDays = Number(this.dataset.maxDays) || 7;
          const locale = this.dataset.locale || document.documentElement.lang || navigator.language || 'en';
          const start = this.addBusinessDays(new Date(), minDays);
          const end = this.addBusinessDays(new Date(), maxDays);
          const formatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' });
          const range = this.querySelector('[data-delivery-range]');
          if (range) range.textContent = `${formatter.format(start)} - ${formatter.format(end)}`;
          const flag = this.querySelector('[data-country-flag]');
          if (flag) flag.textContent = this.countryFlag(this.dataset.countryCode);
        }

        addBusinessDays(date, numberOfDays) {
          const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
          let added = 0;
          while (added < numberOfDays) {
            result.setDate(result.getDate() + 1);
            const day = result.getDay();
            if (day !== 0 && day !== 6) added += 1;
          }
          return result;
        }

        countryFlag(countryCode) {
          if (!countryCode || countryCode.length !== 2) return '';
          return String.fromCodePoint(
            ...countryCode.toUpperCase().split('').map((letter) => 127397 + letter.charCodeAt(0))
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["arctic-v2-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arctic-v2-tabs')) {
    customElements.define(
      'arctic-v2-tabs',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
          this.panelWrap = this.querySelector('.arctic-v2-tabs__panels');
          this.activeTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
          this.activePanel = this.panels.find((panel) => panel.dataset.panel === this.activeTab.dataset.tab);
          this.panels.forEach((panel) => {
            const active = panel === this.activePanel;
            panel.hidden = !active;
            panel.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.activate(tab));
            tab.addEventListener('keydown', (event) => {
              if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
              event.preventDefault();
              let nextIndex = index;
              if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
              if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
              if (event.key === 'Home') nextIndex = 0;
              if (event.key === 'End') nextIndex = this.tabs.length - 1;
              this.tabs[nextIndex].focus();
              this.activate(this.tabs[nextIndex]);
            });
          });
        }

        activate(activeTab) {
          if (!activeTab) return;
          if (this.isAnimating) {
            this.pendingTab = activeTab;
            return;
          }
          if (activeTab === this.activeTab) return;

          const nextPanel = this.panels.find((panel) => panel.dataset.panel === activeTab.dataset.tab);
          if (!nextPanel || !this.activePanel || !this.panelWrap) return;

          this.isAnimating = true;
          const previousTab = this.activeTab;
          const previousPanel = this.activePanel;
          const previousIndex = this.tabs.indexOf(previousTab);
          const nextIndex = this.tabs.indexOf(activeTab);
          const direction = nextIndex > previousIndex ? 1 : -1;

          this.tabs.forEach((tab) => {
            const active = tab === activeTab;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });

          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reducedMotion) {
            previousPanel.hidden = true;
            previousPanel.setAttribute('aria-hidden', 'true');
            nextPanel.hidden = false;
            nextPanel.setAttribute('aria-hidden', 'false');
            this.completeTransition(activeTab, nextPanel);
            return;
          }

          const previousHeight = Math.ceil(previousPanel.getBoundingClientRect().height);
          nextPanel.hidden = false;
          nextPanel.setAttribute('aria-hidden', 'false');
          previousPanel.setAttribute('aria-hidden', 'true');
          nextPanel.classList.add('is-measuring');
          const nextHeight = Math.ceil(nextPanel.getBoundingClientRect().height);
          nextPanel.classList.remove('is-measuring');
          previousPanel.classList.add('is-leaving');
          nextPanel.classList.add('is-entering');
          this.panelWrap.style.height = `${previousHeight}px`;
          this.panelWrap.offsetHeight;

          const timing = {
            duration: 480,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'both',
          };
          const animations = [
            this.panelWrap.animate(
              [{ height: `${previousHeight}px` }, { height: `${nextHeight}px` }],
              timing
            ),
            previousPanel.animate(
              [
                { opacity: 1, transform: 'translateX(0)' },
                { opacity: 0, transform: `translateX(${-10 * direction}px)` },
              ],
              timing
            ),
            nextPanel.animate(
              [
                { opacity: 0, transform: `translateX(${10 * direction}px)` },
                { opacity: 1, transform: 'translateX(0)' },
              ],
              timing
            ),
          ];

          Promise.all(animations.map((animation) => animation.finished))
            .then(() => {
              this.panelWrap.style.height = `${nextHeight}px`;
              animations.forEach((animation) => animation.cancel());
              previousPanel.hidden = true;
              previousPanel.classList.remove('is-leaving');
              nextPanel.classList.remove('is-entering');
              window.requestAnimationFrame(() => {
                this.panelWrap.style.height = '';
                this.completeTransition(activeTab, nextPanel);
              });
            })
            .catch(() => {
              this.isAnimating = false;
            });
        }

        completeTransition(activeTab, activePanel) {
          this.activeTab = activeTab;
          this.activePanel = activePanel;
          this.isAnimating = false;
          const pendingTab = this.pendingTab;
          this.pendingTab = null;
          if (pendingTab && pendingTab !== this.activeTab) {
            window.requestAnimationFrame(() => this.activate(pendingTab));
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["maison-benefit-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maison-benefit-grid')) {
    customElements.define('maison-benefit-grid', class extends HTMLElement {
      connectedCallback() {
        this.output = this.querySelector('[data-maison-bundle-quantity]');
        this.attempts = 0;
        this.findBundle();
      }

      findBundle() {
        const bundle = document.querySelector('kaching-bundles-block');
        if (bundle) {
          this.bundle = bundle;
          ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach((eventName) => {
            bundle.addEventListener(eventName, () => window.setTimeout(() => this.update(), 50));
          });
          new MutationObserver(() => this.update()).observe(bundle, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['class', 'aria-checked']
          });
          this.update();
          return;
        }
        this.attempts += 1;
        if (this.attempts < 80) window.setTimeout(() => this.findBundle(), 150);
      }

      update() {
        if (!this.output || !this.bundle) return;
        const selected = this.bundle.querySelector('.kaching-bundles__bar--selected, .kaching-bundles__bar[aria-checked="true"]');
        if (!selected) return;
        const quantityAttribute = selected.dataset.kachingQuantity || selected.dataset.quantity;
        const title = selected.querySelector('.kaching-bundles__bar-title')?.textContent || selected.textContent || '';
        const titleMatch = title.match(/\b(\d+)\s*bottles?\b/i) || title.match(/buy\s+(\d+)/i);
        const quantity = Number(quantityAttribute || titleMatch?.[1]);
        if (!Number.isFinite(quantity) || quantity < 1) return;
        this.output.textContent = quantity === 1
          ? '1 Bottle Shipped Every Month'
          : `${quantity} Bottles Shipped Every ${quantity} Months`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["maison-shipping-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maison-shipping-bar')) {
    customElements.define('maison-shipping-bar', class extends HTMLElement {
      connectedCallback() {
        this.update();
        this.timer = window.setInterval(() => this.updateCountdown(), 60000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      update() {
        this.updateCountdown();
        const start = this.addBusinessDays(new Date(), Number(this.dataset.minDays) || 3);
        const end = this.addBusinessDays(new Date(), Number(this.dataset.maxDays) || 5);
        const locale = this.dataset.locale || document.documentElement.lang || 'en';
        const range = this.querySelector('[data-maison-delivery-range]');
        if (range) range.textContent = this.formatRange(start, end, locale);
        const flag = this.querySelector('[data-maison-country-flag]');
        if (flag) flag.textContent = this.countryFlag(this.dataset.countryCode);
      }

      updateCountdown() {
        const now = new Date();
        const cutoff = new Date(now);
        cutoff.setHours(Number(this.dataset.cutoffHour) || 23, 59, 59, 999);
        if (cutoff <= now) cutoff.setDate(cutoff.getDate() + 1);
        const minutes = Math.max(0, Math.floor((cutoff - now) / 60000));
        const hours = Math.floor(minutes / 60);
        const remaining = minutes % 60;
        const output = this.querySelector('[data-maison-countdown]');
        if (output) output.textContent = `${hours}h, ${remaining}m`;
      }

      addBusinessDays(date, days) {
        const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
        }
        return result;
      }

      formatRange(start, end, locale) {
        if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
          const day = new Intl.DateTimeFormat(locale, { day: 'numeric' });
          const month = new Intl.DateTimeFormat(locale, { month: 'short' });
          return `${day.format(start)}–${day.format(end)} ${month.format(end)}`;
        }
        const formatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' });
        return `${formatter.format(start)}–${formatter.format(end)}`;
      }

      countryFlag(countryCode) {
        if (!countryCode || countryCode.length !== 2) return '';
        return String.fromCodePoint(...countryCode.toUpperCase().split('').map((letter) => 127397 + letter.charCodeAt(0)));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["maison-template-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    const addTemplateClass = () => document.body?.classList.add('maison-arctic-v4');
    addTemplateClass();
    if (!document.body) document.addEventListener('DOMContentLoaded', addTemplateClass, { once: true });

    const marker = document.querySelector('[data-maison-template-styles]');
    let variantPrices = [];
    let kachingEventQuantity = null;

    try {
      const parsedVariantPrices = JSON.parse(marker?.dataset.variantPrices || '[]');
      variantPrices = Array.isArray(parsedVariantPrices) ? parsedVariantPrices : [];
    } catch (error) {
      variantPrices = [];
    }

    const selectedBundle = () => {
      const bundle = document.querySelector('kaching-bundles-block');
      if (!bundle) return null;

      const selected = bundle.querySelector(
        '.kaching-bundles__bar--selected, .kaching-bundles__bar[aria-checked="true"]'
      );
      if (selected) return selected;

      const checked = bundle.querySelector('.kaching-bundles__bar input[type="radio"]:checked');
      return checked?.closest('.kaching-bundles__bar') || null;
    };

    const firstText = (root, selectors) => {
      for (const selector of selectors) {
        const element = root.querySelector(selector);
        const value = element?.textContent?.replace(/\s+/g, ' ').trim();
        if (value) return value;
      }
      return '';
    };

    const currentVariant = () => {
      const variantInput = document.querySelector(
        'product-form form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]'
      );
      const selectedId = String(variantInput?.value || marker?.dataset.selectedVariantId || '');
      return variantPrices.find((variant) => String(variant.id) === selectedId) || variantPrices[0] || null;
    };

    const variantReferencePrice = () => {
      const variant = currentVariant();
      if (!variant) return null;

      const comparePrice = Number(variant.compare_at_price);
      const price = Number(variant.price);
      if (Number.isFinite(comparePrice) && comparePrice > 0) return comparePrice;
      return Number.isFinite(price) && price > 0 ? price : null;
    };

    const quantityFromDetail = (detail) => {
      if (!detail) return null;

      if (Array.isArray(detail.variantIdQuantities)) {
        const total = detail.variantIdQuantities.reduce(
          (sum, variant) => sum + (Number(variant?.quantity) || 0),
          0
        );
        if (total > 0) return total;
      }

      const quantity = Number(detail.quantity || detail.dealQuantity);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : null;
    };

    const bogoQuantityFromBundle = (selected) => {
      const title = firstText(selected, [
        '.kaching-bundles__bar-title',
        '[data-kaching-bundles-title]',
        '[class*="bar-title"]'
      ]);
      const buyGet = title.match(/\bbuy\s*(\d+).*?\bget\s*(\d+)/i);
      if (buyGet) return Number(buyGet[1]) + Number(buyGet[2]);

      const plus = title.match(/\b(\d+)\s*\+\s*(\d+)\b/);
      return plus ? Number(plus[1]) + Number(plus[2]) : null;
    };

    const attributeQuantityFromBundle = (selected) => {
      const value =
        selected.getAttribute('data-kaching-total-quantity') ||
        selected.getAttribute('data-total-quantity') ||
        selected.getAttribute('data-kaching-quantity') ||
        selected.getAttribute('data-quantity') ||
        selected.getAttribute('quantity');
      const quantity = Number(value);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : null;
    };

    const parseMoney = (text) => {
      const token = String(text || '').match(/-?\d[\d\s.,]*\d|-?\d/);
      if (!token) return null;

      let value = token[0].replace(/\s/g, '');
      const lastComma = value.lastIndexOf(',');
      const lastDot = value.lastIndexOf('.');
      const decimalIndex = Math.max(lastComma, lastDot);
      const decimalDigits = decimalIndex === -1 ? 0 : value.length - decimalIndex - 1;

      if (decimalIndex !== -1 && decimalDigits > 0 && decimalDigits <= 2) {
        const whole = value.slice(0, decimalIndex).replace(/[.,]/g, '');
        const fraction = value.slice(decimalIndex + 1).replace(/[.,]/g, '');
        value = `${whole}.${fraction}`;
      } else {
        value = value.replace(/[.,]/g, '');
      }

      const number = Number.parseFloat(value);
      return Number.isFinite(number) ? number : null;
    };

    const formatMoneyLike = (reference, value) => {
      if (!Number.isFinite(value) || value <= 0) return '';

      const source = String(reference || '').replace(/\s+/g, ' ').trim();
      const match = source.match(/-?\d[\d\s.,]*\d|-?\d/);
      if (!match) return '';

      const numberText = match[0];
      const prefix = source.slice(0, match.index);
      const suffix = source.slice((match.index || 0) + numberText.length);
      const decimalMatch = numberText.match(/([.,])(\d{1,2})$/);
      const decimalSeparator = decimalMatch?.[1] || '.';
      const decimals = decimalMatch?.[2].length || 0;
      const locale = decimalSeparator === ',' ? 'de-DE' : 'en-US';
      const formatted = value.toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });

      return `${prefix}${formatted}${suffix}`.trim();
    };

    const savingFromBundle = () => {
      const selected = selectedBundle();
      if (!selected) return '';

      const price = firstText(selected, [
        '.kaching-bundles__bar-price',
        '[data-kaching-bundles-price]',
        '.kaching-bundles__bar-price-wrapper [class*="price"]'
      ]);
      const priceValue = parseMoney(price);
      const unitReferencePrice = variantReferencePrice();
      const quantity =
        bogoQuantityFromBundle(selected) ||
        kachingEventQuantity ||
        attributeQuantityFromBundle(selected);

      if (priceValue === null || unitReferencePrice === null || !quantity) return '';

      const originalTotal = (unitReferencePrice / 100) * quantity;
      const savingValue = originalTotal - priceValue;
      const amount = formatMoneyLike(marker?.dataset.moneyReference || price, savingValue);
      return amount ? `Save ${amount}` : '';
    };

    const updateSaving = () => {
      const saving = savingFromBundle();
      document.querySelectorAll('.main-product-atc .main-atc__label__text').forEach((label) => {
        if (saving) label.dataset.maisonSaving = saving;
        else delete label.dataset.maisonSaving;
      });
    };

    const bindBundle = () => {
      const bundle = document.querySelector('kaching-bundles-block');
      if (!bundle || bundle.dataset.maisonCtaBound === 'true') return Boolean(bundle);
      bundle.dataset.maisonCtaBound = 'true';

      bundle.addEventListener('deal-bar-selected', () => {
        kachingEventQuantity = null;
        window.setTimeout(updateSaving, 50);
      });
      ['variant-selected', 'variants-changed'].forEach((eventName) => {
        bundle.addEventListener(eventName, (event) => {
          kachingEventQuantity = quantityFromDetail(event.detail) || kachingEventQuantity;
          window.setTimeout(updateSaving, 50);
        });
      });
      new MutationObserver(updateSaving).observe(bundle, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'aria-checked']
      });
      updateSaving();
      return true;
    };

    let attempts = 0;
    const findBundle = () => {
      if (bindBundle() || attempts > 80) return;
      attempts += 1;
      window.setTimeout(findBundle, 150);
    };

    updateSaving();
    findBundle();
    document.addEventListener('kaching-bundles-block-loaded', () => {
      bindBundle();
      updateSaving();
    });
    document.addEventListener('change', (event) => {
      if (event.target.matches('form[action*="/cart/add"] [name="id"]')) {
        window.setTimeout(updateSaving, 0);
      }
    });
    ['variant:change', 'variant-changed', 'product:variant-change'].forEach((eventName) => {
      document.addEventListener(eventName, () => window.setTimeout(updateSaving, 0));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["maison-v5-availability"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maison-v5-countdown')) {
    customElements.define('maison-v5-countdown', class extends HTMLElement {
      connectedCallback() {
        this.output = this.querySelector('[data-countdown-time]');
        this.label = this.querySelector('[data-countdown-label]');
        this.activeLabel = this.label.textContent;
        const deadline = this.dataset.deadline?.trim();
        if (deadline) {
          this.deadline = Date.parse(deadline);
        } else {
          const duration = this.dataset.duration?.match(/^(\d{1,3}):([0-5]\d):([0-5]\d)$/);
          if (!duration) return;
          const seconds = Number(duration[1]) * 3600 + Number(duration[2]) * 60 + Number(duration[3]);
          const key = `maison-v5-countdown:${this.dataset.key}:${this.dataset.duration}`;
          this.deadline = Date.now() + seconds * 1000;
          try {
            const storedDeadline = Number(localStorage.getItem(key));
            if (Number.isFinite(storedDeadline) && storedDeadline > 0) this.deadline = storedDeadline;
            else localStorage.setItem(key, String(this.deadline));
          } catch {}
        }
        if (!Number.isFinite(this.deadline)) return;
        this.hidden = false;
        this.tick();
        if (this.deadline > Date.now()) this.interval = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      tick() {
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        this.output.textContent = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60]
          .map(value => String(value).padStart(2, '0')).join(':');
        this.label.textContent = remaining ? this.activeLabel : this.dataset.expiredLabel;
        if (!remaining) window.clearInterval(this.interval);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
